import { Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import React, { Component, MouseEvent } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import routes from "../constants/routes";
import { User } from "../constants/interfaces";
import { Icon } from "./icons/Icon";
import { authActions } from "../reducers/authentication";

const styles = (theme: Theme) =>
  createStyles({
    dropdownTrigger: {
      display: "flex",
      marginBottom: theme.spacing(1)
    },
    dropdownButton: {
      padding: 0
    },
    dropdownLabel: {
      fontWeight: "bold"
    }
  });

type Props = RouteComponentProps & {
  user: User;
  classes?: any;
  logout?: () => Promise<void>;
  onLogoutClick?: () => void;
  onProfileClick?: () => void;
};

type State = {
  anchorEl: HTMLElement | null;
};

class ProfileCard extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      anchorEl: null
    };
    this.closeMenu = this.closeMenu.bind(this);
    this.goToProfile = this.goToProfile.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.openMenu = this.openMenu.bind(this);
  }
  openMenu(e: MouseEvent<HTMLButtonElement>) {
    this.setState({
      anchorEl: e.currentTarget
    });
  }

  closeMenu() {
    this.setState({
      anchorEl: null
    });
  }

  goToProfile() {
    const { history, onProfileClick } = this.props;
    history.push(routes.MY_DETAILS.url);
    if (onProfileClick) {
      onProfileClick();
    }
    this.closeMenu();
  }

  async onLogout() {
    const { logout, onLogoutClick, history } = this.props;
    this.closeMenu();
    onLogoutClick && onLogoutClick();
    logout && (await logout());
    history.push(routes.LOGIN.url);
  }

  render() {
    const { anchorEl } = this.state;
    const { user, classes } = this.props;
    const fullName = `${user.givenName} ${user.surname}`;
    return (
      <div>
        <div className={classes.dropdownTrigger}>
          <Typography variant="body1" className={classes.dropdownText}>
            {fullName}
          </Typography>
          <Button
            aria-owns={anchorEl ? "profile-dropdown" : undefined}
            aria-haspopup="true"
            data-test-control="menu"
            onClick={this.openMenu}
            className={classes.dropdownButton}
          >
            <Icon name="expand_more" />
          </Button>
        </div>
        <Typography>{user.emailAddress}</Typography>
        <Menu
          id="profile-dropdown"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.closeMenu}
        >
          <MenuItem data-test-control="profile" onClick={this.goToProfile}>
            My Details
          </MenuItem>
          <MenuItem data-test-control="logout" onClick={this.onLogout}>
            Log Out
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapDispatchToProps = {
  logout: authActions.logoutUser
};

export const StyledProfileCard = withStyles(styles)(ProfileCard);
const connected = connect(
  null,
  mapDispatchToProps
)(withRouter(StyledProfileCard));

export { connected as ProfileCard };
